import { createTheme, Theme, ThemeOptions } from '@material-ui/core/styles';
import { Overrides } from '@material-ui/core/styles/overrides';
import { Colors } from 'react-scale/components/legacy-css/global_css';
import { baseOverrides } from 'react-scale/components/ui/theme';
import { NUCLEUS_COLORS } from './product/theme';
import color from 'color';

declare module '@material-ui/core/styles' {
  export function createTheme<TCustomTheme>(
    theme: ThemeOptions & TCustomTheme,
  ): Theme & TCustomTheme;
}
declare module '@material-ui/core/styles/createTypography' {
  export interface TypographyUtils {
    htmlFontSize: number;
  }
}

export type Intent = 'success' | 'info' | 'warning' | 'error';

const RemotasksTheme = {
  typography: {
    fontSize: 14,
    fontFamily: 'var(--font-family)',
    fontFamilyMono: 'var(--font-family-code)',
  },
  palette: {
    primary: {
      light: color(Colors.RemoBlue).lighten(0.2).toString(),
      main: Colors.RemoBlue,
      dark: color(Colors.RemoBlue).darken(0.2).toString(),
      contrastText: '#fff',
    },
    secondary: {
      light: color(Colors.RemoBlue).lighten(0.4).toString(),
      main: color(Colors.RemoBlue).lighten(0.2).toString(),
      dark: Colors.RemoBlue,
      contrastText: '#fff',
    },
    success: {
      light: color(Colors.RemoGreen).lighten(0.2).toString(),
      main: Colors.RemoGreen,
      dark: color(Colors.RemoGreen).darken(0.2).toString(),
      contrastText: '#fff',
    },
    // same as primary
    info: {
      light: color(Colors.RemoBlue).lighten(0.2).toString(),
      main: Colors.RemoBlue,
      dark: color(Colors.RemoBlue).darken(0.2).toString(),
      contrastText: '#fff',
    },
    warning: {
      light: color(Colors.RemoGold).lighten(0.2).toString(),
      main: Colors.RemoGold,
      dark: color(Colors.RemoGold).darken(0.2).toString(),
      contrastText: '#fff',
    },
    error: {
      light: color(Colors.RemoRed).lighten(0.2).toString(),
      main: Colors.RemoRed,
      dark: color(Colors.RemoRed).darken(0.2).toString(),
      contrastText: '#fff',
    },
    expert: {
      light: color(Colors.Teal500).lighten(0.2).toString(),
      main: Colors.Teal500,
      dark: color(Colors.Teal500).darken(0.2).toString(),
      contrastText: '#fff',
    },
    background: {
      one: Colors.RemoGray01,
      two: Colors.RemoGray05,
    },
  },
  colors: {
    primary1: Colors.RemoBlue,
    blue: Colors.RemoBlue,
    lightSkyBlue: Colors.LightSkyBlue,
    green: Colors.RemoGreen,
    gold: Colors.RemoGold,
    red: Colors.RemoRed,
    white: '#fff',
    gray01: Colors.RemoGray01,
    gray05: Colors.RemoGray05,
    gray10: Colors.RemoGray10,
    gray20: Colors.RemoGray20,
    gray50: Colors.RemoGray50,
    gray75: Colors.RemoGray75,
    teal500: Colors.Teal500,
    black: '#000',
    scaleBlue: Colors.ScaleBlue,
    scaleGreen: Colors.ScaleGreen,
    scaleRed: Colors.ScaleRed,
    ...NUCLEUS_COLORS,
  },
  borderRadius: '8px',
  boxShadowLarge: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
  boxShadowLargeTop: 'rgba(100, 100, 111, 0.2) 0px -7px 29px 0px',
} as const;

const defaultTheme = createTheme<typeof RemotasksTheme>({
  ...RemotasksTheme,
  overrides: baseOverrides as Overrides,
});

export type RemotasksUITheme = typeof defaultTheme;

export default defaultTheme;
